import { Form } from "react-bootstrap";
import styled from "styled-components";

const StyledFormCheck = styled(Form.Check)`
    font-weight: 500;
    font-size: 17px;
    color: #8a0538;
    border-color: #8a0538;
    .form-check-input {
        border: 1px solid #8a0538;
        background: transparent;
        &:checked {
            background-color: #8a0538;
            border-color: #8a0538;
        }
        &:focus {
            box-shadow: none !important;
        }
    }
`;

export default { StyledFormCheck };
